export enum ScraperSection {
  PROPERTY_CARD = 'PROPERTY_CARD', TAX_DOCUMENTS = 'TAX_DOCUMENTS', PROPERTY_CARD_AND_TAX_DOCUMENTS = 'PROPERTY_CARD_AND_TAX_DOCUMENTS', DEEDS = 'DEEDS', ALL = 'ALL'
}